import * as React from 'react';
import classnames from 'classnames';
import { questionErrorMessage } from '../../../../../../constants/applicationMessage';
import RichTextField from '../../../../../common/richTextField';
import { REDIRECT_LABEL } from '../../../../../../mapping/project';
import MultimediaBubble from '../../../common/MultimediaBubble';
import { MULTIMEDIA_TYPES, ProjectLanguage } from '@nexxt/common/types';
import HelperTooltip from '../../../../../common/HelperTooltip';
import ReactTooltip from 'react-tooltip';
import { HELPER_TOOLTIP_MAPPING } from '../../../../../../mapping/helperTooltip';

interface RedirectTextItemProps {
    redirectSetting: any;
    languages: ProjectLanguage[];
    disabled?: boolean;
    defaultText?: string;
    editEnabled?: boolean;
    errorObject: any;
    setValue?: (value: any) => void; // keyName: string,
    addNewEditor: (
        languageCode: string,
        position: number,
        type?: MULTIMEDIA_TYPES,
        data?
    ) => void;
    removeEditor: (languageCode: string, index: number) => void;
    updateRedirectMessage: (keyName, value, language, textIndex, type) => void;
}

const RedirectTextItem: React.SFC<RedirectTextItemProps> = ({
    redirectSetting,
    languages,
    defaultText,
    disabled,
    errorObject,
    editEnabled,
    addNewEditor,
    removeEditor,
    setValue,
    updateRedirectMessage
}) => {
    // const followUpTexts = redirectSetting.texts;
    // const followUpObject = {};
    // followUpTexts.forEach((followUpText) => {
    //     followUpObject[followUpText.language] = followUpText;
    // });
    return (
        <React.Fragment>
            <div className="col-md-12 form-group-header">
                {`Survey  ${REDIRECT_LABEL[redirectSetting.type]}`}
            </div>
            <MultimediaBubble
                languages={languages}
                value={redirectSetting.multimediaTexts}
                defaultText={defaultText}
                disabled={!editEnabled}
                questionError={errorObject}
                hideQuestionTextLabel
                setValue={(keyName, value) => setValue(value)}
                setValueWithLanguage={updateRedirectMessage}
                addNewBubble={addNewEditor}
                removeBubble={removeEditor}
                settings={{ showClose: true, showDynamicReference: true }}
            />
        </React.Fragment>
    );
};

export default RedirectTextItem;
